import { render, staticRenderFns } from "./SunstudyControls.vue?vue&type=template&id=ed618374&scoped=true&"
import script from "./SunstudyControls.vue?vue&type=script&lang=js&"
export * from "./SunstudyControls.vue?vue&type=script&lang=js&"
import style0 from "./SunstudyControls.vue?vue&type=style&index=0&id=ed618374&scoped=true&lang=scss&"
import style1 from "./SunstudyControls.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed618374",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VBtnToggle,VIcon,VSlider})
